<template>
  <div>
    <expand-login-anomaly-details v-if="details && isLoginType" :details="details"></expand-login-anomaly-details>
    <expand-process-anomaly-details
      v-else-if="details && isProcessType"
      :details="details"
    ></expand-process-anomaly-details>
    <expand-network-anomaly-details :details="details" v-else></expand-network-anomaly-details>
  </div>
</template>

<script>
import ExpandLoginAnomalyDetails from '@/components/expand/ExpandLoginAnomalyDetails.vue'
import ExpandProcessAnomalyDetails from '@/components/expand/ExpandProcessAnomalyDetails.vue'
import ExpandNetworkAnomalyDetails from '@/components/expand/ExpandNetworkAnomalyDetails.vue'

export default {
  name: 'ExpandAnomalyDetails',
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    isLoginType () {
      return this.details.anomalyCategory.includes('LOGIN')
    },
    isProcessType () {
      return this.details.anomalyCategory.includes('PROCESS')
    }
  },
  components: {
    ExpandLoginAnomalyDetails,
    ExpandProcessAnomalyDetails,
    ExpandNetworkAnomalyDetails
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.material-icons {
  font-size: 1.3em;
  line-height: 36px;
  vertical-align: middle;
  color: var(--gray-500);
  background: transparent;
}

.el-divider--vertical {
  margin: 0px;
}

>>> .el-button {
  background-color: var(--aluminum-800);
  color: white;
}

.footer-buttons {
  &.center {
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/expand/ExpandAnomalyDetails.vue